export { IreRecordDetail } from './IreRecordDetail';
